module.exports = __webpack_public_path__ + "img/image10@2x.3ed5b3f9.png";